<template>
  <div class="notice-box">
    <div class="header-search-box flex align-items-center border-box">
      <div class="flex align-items-center" style="margin-right: 8px">
        <div style="width: 80px">标题名称 :</div>
        <a-input
          style="width: 140px"
          type="text"
          v-model="queryCriteria.titleName"
          allowClear
          placeholder=""
        />
      </div>
      <div
        class="search-btn flex flex-center align-items-center"
        @click="goQuery"
      >
        <img class="img-box" src="../../assets/images/img48.png" alt="" />
        <div>查询</div>
      </div>
      <div class="add-btn"  v-if="$store.state.role=='education-guide-role'" style="margin-left: 6px" @click="jumpPage">新增</div>
      <div class="add-btn" v-if="$store.state.role=='education-guide-role'" style="margin-left: 6px" @click="batchsubmis">
        批量发布
      </div>
    </div>
    <div>
      <a-table
        style="text-align: center"
        :row-selection="rowSelection"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="datalist"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="true"
       rowKey="id"
      >
       <!--  -->
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="sbs" slot-scope="text, record, index">
          <span v-if="text=='0'">
              未发布
          </span>
           <span v-else>
              已发布
          </span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 10px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            @click="editInfo(record)"
            v-if="$store.state.role=='education-guide-role'"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>

          <!-- && $route.name!='szMicroClass' -->
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            v-if="$store.state.role=='education-guide-role' && record.izPublish=='0'"
            @click="ispublish(record)"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img100.png"
              alt=""
            />
            <span>发布</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
            v-if="$store.state.role=='education-guide-role'"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer; margin-right: 10px"
            @click="preview(record)"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img51.png"
              alt=""
            />
            <span>预览</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条工作通知吗?</p>
    </a-modal>
        <a-modal
      title="您确定发布吗"
      :visible="showPublishModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handlePublish"
      @cancel="showPublishModel = false"
    >
      <p>您确定要发布该条工作通知吗?</p>
    </a-modal>
    <a-modal
      :title="titles"
      width="40%"
      :visible="importshow"
      :maskClosable="false"
      :keyboard="false"
      @cancel="importshow = false"
      @ok="handleOks"
      ok-text="确认"
      cancel-text="取消"
    >
      <div>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :label-col="labelCol"
          :rules="rules"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="标题名称" prop="titleName">
            <a-input
              type="text"
              v-model="form.titleName"
              allowClear
              placeholder=""
            />
          </a-form-model-item>
          <a-form-model-item label="公告内容" prop="noticeContent">
            <base-editor ref="baseEditor" :height="250" :text="form.noticeContent" v-model="form.noticeContent" style="z-index: 1000"
              ></base-editor>
            <!-- <a-upload
              :before-upload="beforeUpload"
              accept=".pdf,.mp4"
              :showUploadList="false"
              :disabled="loadings"
            >
              <a-button
                style="margin-right: 20px"
                :loading="loadings"
                :disabled="loadings"
                >上传文件</a-button
              >
            </a-upload> -->

          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";
import BaseEditor from "@/components/common/BaseEditor.vue";
import { getAction, postAction, putAction, deleteAction,post1Action} from "@/api/index";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "标题名称",
    dataIndex: "titleName",
    id: "titleName",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "izPublish",
    id: "izPublish",
    align: "center",
    scopedSlots: { customRender: "sbs" },
    width: 100,
  },
  {
    title: "操作",
    // slots: { title: "action" },
    id: "action",
    align: "center",
    width: 340,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "",
  components: { BaseEditor },
  data() {
    return {
      columns: columns,
      queryCriteria: {
        titleName: "",
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      selectedRowKeys: [],
      titles: "",
      importshow: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
      loadings: false,
      form: {
        titleName: "",
        noticeContent: "",
      },
      rules: {
        titleName: [
          {
            required: true,
            message: "请输入标题名称",
            trigger: "blur",
          },
        ],
        noticeContent: [
          {
            required: true,
            message: "请输入公告内容",
            trigger: "change",
          },
        ],
      },
      type: "add",
      datalist:[],
      loading:false,
      showDeleteModel:false,
      showPublishModel:false,
    };
  },
  computed: {
    rowSelection() {
      if(this.$store.state.role=='education-guide-role'){
         return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps,
        // 其他 row-selection 的配置
      };
      }else{
          return '';
      }
    },
  },
  created() {},
  mounted() {
    this.goQuery();
  },
  methods: {
    beforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      let url = "/sys/common/upload";
      this.loadings = true;
      postAction(url, formData).then((res) => {
        if (res.code === 200) {
          // console.log("111111");
          this.$message.success("导入成功");
          let that = this;
          that.loadings = false;
        } else {
          this.$message.warning(res.message);
          this.loadings = false;
        }
      });
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.izPublish == "1" // Column configuration not to be checked
        },
      };
    },
    handleOks() {
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          if (this.type == "add") {
             console.log(this.form);
              postAction("/lxbase/lxNotice/add", this.form).then((res) => {
                if (res.code === 200) {
                   this.$message.success("新增成功");
                   this.importshow = false;
                   this.goQuery();
                } else {
                  this.$message.error(res.message);
                }
              });
          } else {
             console.log(this.form);
              putAction("/lxbase/lxNotice/edit", this.form).then((res) => {
                if (res.code === 200) {
                  this.$message.success("编辑成功");
                   this.importshow = false;
                   this.goQuery();
                } else {
                  this.$message.error(res.message);
                }
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    batchsubmis() {
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量发布的工作通知");
      } else {
        let params = {
          ids: this.selectedRowKeys.join(','),
        };
        post1Action("/lxbase/lxNotice/publishBatch?ids="+this.selectedRowKeys.join(','), params).then((res) => {
          if (res.code === 200) {
            this.$message.success("批量发布成功");
            this.showPublishModel= false;
            this.goQuery();
            this.selectedRowKeys = [];
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    jumpPage() {
      this.titles = "新增工作通知";
      this.importshow = true;
      this.type='add';
      this.form.titleName = "";
      this.form.noticeContent = "";
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loading = true;
      let params={
        pageNo:this.pagination.current,
        pageSize:this.pagination.pageSize,
        titleName:this.queryCriteria.titleName,
      }
      if(this.$store.state.role!='education-guide-role'){
        params.ispublish='1';
      }
      getAction("/lxbase/lxNotice/list", params).then((res) => {
          if (res.code === 200) {
            console.log(res);
            this.datalist=res.result.records;
            this.pagination.total=res.result.total;
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
       });
    },
    handleOk() {
      deleteAction('/lxbase/lxNotice/delete', {id: row.id}).then((res) => {
        if (res.code === 200) {
          // console.log("111111");
          this.$message.success("删除成功");
          this.showDeleteModel = false;
          this.goQuery();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.titles = "编辑工作通知";
      this.importshow = true;
      this.type='edit';
      this.form=row;
      let that=this;
      setTimeout(function(){
         if(that.$refs.baseEditor){
         that.$refs.baseEditor.value=row.noticeContent;
         }
      },10)
     
      // this.$refs.baseEditor.value=row.noticeContent;
      that.$forceUpdate();
    },
    ispublish(row){
         this.showPublishModel= true;
         this.publishId=row.id;
    },
    handlePublish(){
         let params = {
          ids:this.publishId,
        };
        post1Action("/lxbase/lxNotice/publishBatch?ids="+this.publishId, params).then((res) => {
          if (res.code === 200) {
            this.$message.success("发布成功");
            this.showPublishModel= false;
            this.goQuery();
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    preview(row) {
      this.$router.push({
        path:'/personalCenter/noticeDetails',
        query:{
          id:row.id,
        }
      })
    },
    goQuery() {
      const pagination = {
        current: 1,
        pageSize: 10,
      };
      this.handleTableChange(pagination);
    },
  },
};
</script>

<style scoped lang="scss">
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: rgba(156, 3, 5, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2155b5;
  border-radius: 10px;
}
.notice-box {
  padding: 15px 30px;
}
.add-btn {
  width: 86px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #2155b5;
  border-radius: 6px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.mb8 {
  margin-bottom: 8px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}

.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}

.table-box {
  text-align: center;
}

.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }

  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }

  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}

.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  margin-bottom: 15px;

  .input-style {
    width: 180px;
    height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 20px 0 6px;
  }

  .search-btn {
    width: 90px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #2155b5;
    border-radius: 6px;
    margin-left: 8px;

    // margin-right: 8px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}

.downmb {
  line-height: 40px;
  cursor: pointer;
  color: #0f5ef1cc;
  /*margin-bottom:20px;*/
}

.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
</style>
